<header class="header">
  <!-- Left Section: Logos & Search -->
  <div class="header-left">
    <button
      class="mobile-toggle-btn"
      (click)="toggleMobileMenu()"
      aria-label="Toggle Navigation Menu"
    >
      <i class="fa-solid fa-bars"></i>
    </button>
    <div class="logo-container">
      <img src="img/hropal-logo.svg" alt="HR OpalPlus" class="app-logo" />
    </div>

    <div class="search-container" (keydown)="onSearchKeydown($event)">
      <i class="hgi hgi-stroke hgi-rounded hgi-search-01 search-icon"></i>
      <input
        type="text"
        placeholder="Search for anything"
        class="search-input form-input"
        autocomplete="off"
        [ngModel]="searchTerm()"
        (ngModelChange)="onSearchChange($event)"
        (focus)="onSearchFocus()"
      />
      <span class="search-shortcut header-search-k">⌘ K</span>

      @if (isSearchOpen()) {
        <div class="search-results">
          @if (searchResults().length) {
            @for (item of searchResults(); track item.id; let i = $index) {
              <button
                type="button"
                class="search-result-item"
                [class.active]="isSearchResultActive(i)"
                (click)="selectSearchResult(item)"
              >
                {{ item.name }}
                @if (item.parentName) {
                  <span class="search-result-parent">{{ item.parentName }}</span>
                }
              </button>
            }
          } @else {
            <div class="search-no-results">No matching menu found</div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Right Section -->
  <div class="header-right">
    <div class="menu-items">
      <!-- Hidden for Phase 1 (not functional yet) — see Navigation story: remove AI/Integration top bar icons
      <div class="menu-item ai-suggestions">
        <svg
          class="ai-sparkles-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3L13.5 8.5L19 10L13.5 11.5L12 17L10.5 11.5L5 10L10.5 8.5L12 3Z"
            fill="url(#ai-grad)"
          />
          <path
            d="M19 16L19.75 18.75L22.5 19.5L19.75 20.25L19 23L18.25 20.25L15.5 19.5L18.25 18.75L19 16Z"
            fill="url(#ai-grad)"
          />
          <path
            d="M6 13L6.5 14.8333L8.33333 15.3333L6.5 15.8333L6 17.6667L5.5 15.8333L3.66667 15.3333L5.5 14.8333L6 13Z"
            fill="url(#ai-grad)"
          />
          <defs>
            <linearGradient
              id="ai-grad"
              x1="3.66667"
              y1="3"
              x2="22.5"
              y2="23"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stop-color="#FF5B5B" />
              <stop offset="50%" stop-color="#6A35F2" />
              <stop offset="100%" stop-color="#00C9FF" />
            </linearGradient>
          </defs>
        </svg>
        <span class="menu-text button-xs">AI suggestions</span>
        <span class="new-badge nav-badge">New</span>
      </div>

      <div class="menu-item integrate">
        <img src="/img/header-icons/integrate.svg" class="menu-icon" alt="integrate icon" />
        <span class="menu-text button-xs">Integrate</span>
      </div>
      -->

      <!-- Hidden for Phase 1 (not functional yet) — see Navigation story: remove AI/Integration/Automate top bar icons
      <div class="menu-item automate">
        <img src="/img/header-icons/automate.svg" class="menu-icon" alt="automate icon" />
        <span class="menu-text button-xs">Automate</span>
      </div>
      -->
    </div>

    <!-- 🔽 Access switcher (self-gates: only when the login holds more than one user group) -->
    <app-access-switcher
      (accessSelected)="onAccessSelected($event)"
      (opened)="onAccessSwitcherOpened()"
    ></app-access-switcher>

    <!-- 🔽 Company switcher (self-gates to sub_admin / super_user via SWITCHABLE_ROLE_TYPES) -->
    <app-company-switcher
      (companySelected)="onCompanySelected($event)"
      (opened)="onCompanySwitcherOpened()"
    ></app-company-switcher>

    <!-- 🔽 Utility components -->
    <div class="utility-actions">
      <app-fullscreen></app-fullscreen>

      @if (!isSuperAdmin) {
        <!-- <app-themeswitcher></app-themeswitcher> -->
        <app-languageswitcher></app-languageswitcher>
      }

      <app-notifications
        [dateFormat]="dateFormat"
        (opened)="onNotificationsOpened()"
      ></app-notifications>

      <app-helpicon></app-helpicon>
    </div>

    <!-- 🔽 User avatar + dropdown -->
    <app-user-profile
      [userProfile]="userProfile"
      [clientLogo]="clientLogo"
      (opened)="onUserDropdownOpened()"
    ></app-user-profile>
  </div>
</header>

<!-- Company switch confirmation -->
<app-confirm-switch-modal
  [isOpen]="isConfirmModalOpen"
  [currentCompany]="switchFromCompany"
  [targetCompany]="switchToCompany"
  [isSwitching]="isSwitching"
  (confirmSwitch)="onConfirmCompanySwitch()"
  (cancelSwitch)="onCancelCompanySwitch()"
></app-confirm-switch-modal>

<!-- Access (role) switch confirmation - same dialog as the company switch -->
<app-confirm-switch-modal
  title="Role Switch"
  message="Are you sure you want to switch the role?"
  [roundImage]="true"
  [isOpen]="isAccessConfirmOpen"
  [fromCard]="switchFromRole"
  [toCard]="switchToRole"
  [isSwitching]="isSwitching"
  (confirmSwitch)="onConfirmAccessSwitch()"
  (cancelSwitch)="onCancelAccessSwitch()"
></app-confirm-switch-modal>
